import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { AnchorComponent } from '@finder/shared/components/anchor/anchor.component';
import { ComponentHeaderComponent } from '@finder/shared/components/component-header/component-header.component';
import { ContentHeaderComponent } from '@finder/shared/components/content-header/content-header.component';
import { GenericTextComponent } from '@finder/shared/components/generic-text/generic-text.component';
import { ImageBlockComponent } from '@finder/shared/components/image-block/image-block.component';
import { PictureComponent } from '@finder/shared/components/picture/picture.component';
import get from 'lodash-es/get';

@Component({
    selector: 'finder-no-results',
    templateUrl: './no-results.component.html',
    styleUrls: ['./no-results.component.scss'],
    standalone: true,
    imports: [
        AnchorComponent,
        CommonModule,
        ComponentHeaderComponent,
        ContentHeaderComponent,
        GenericTextComponent,
        ImageBlockComponent,
        PictureComponent,
    ]
})
export class NoResultsComponent implements OnInit {

    @Input() searchNoResults: any;
    @Input() searchTerm: any;

    image: any;
    noResultsPage: any;

    constructor() { }

    ngOnInit() {
        this.image = this.getImage();
        this.noResultsPage = this.searchNoResults.noResultsPage;
        if (this.noResultsPage) {
            this.noResultsPage.headerData.subtitle =
                this.noResultsPage.headerData.subtitle.replace('{SEARCH_TERM}', decodeURIComponent(this.searchTerm));
        }
    }

    private getImage() {
        const image = get(this.searchNoResults, 'image');
        if (image) {
            return  {
                mobile: image
            };
        }
    }

}
